export const faqList = [
  {
    question: '<bold>מדוע לא מוצג כפתור "בחר" (עבור בחירה ממאגר הקבצים השיתופיים)?</bold>',
    answer: ['כפתור זה יוצג למשתמש רק לאחר הזנת פרטי גוש וחלקה ובמידה וקיימים קבצים מסוג זה במאגר המידע השיתופי עבור הגוש והחלקה שהוקלדו. הקבצים "מפת איתור סביבה", "תצ"א לאיתור חלקה" ו- "מפת ייעודי קרקע"  אינם קיימים במאגר השיתופי.']
  },
  {
    question: '<bold>מדוע לא מוצג כפתור "אתר"?</bold>',
    answer: ['כפתור "אתר" יוצג רק אם המשתמש מילא את השדה "עיר".']
  },
  {
    question: '<bold>אפשר לקבל הסבר לגבי מסך התחשיב?</bold>',
    answer: ['במסך התחשיב מוצגות 3 שיטות חישוב שונות. לכל אחת מהן ניתן משקל יחסי בהתאם להנחיות המשרד במועד ההתקשרות עם חברת אקיורייזר, כאשר ברירת המחדל הינה כדלקמן: חישוב לפי שווי מ"ר דירתי מתואם 0.35, חישוב לפי שווי חדר ממוצע מתואם 0.35 וחישוב לפי שווי מ"ר רשום מתואם 0.3.' +
    // eslint-disable-next-line no-useless-concat
    '{br} ' + 'במקרה בו לא קיים רישום בית משותף, המערכת תציג 2 שיטות חישוב (במקום 3), על בסיס שטח ברישוי בלבד, במשקלים הבאים: חישוב לפי שווי מ"ר דירתי מתואם 0.7 , חישוב לפי שווי חדר ממוצע מתואם 0.3.']
  },
  {
    question: '<bold>מדוע איני יכול לערוך דוח ב- "מאגר דוחות המשרד"?</bold>',
    answer: ['ב- "מאגר דוחות המשרד", אפשרות עריכת דוח תינתן רק למשתמש שיצר את הדוח. יחד עם זאת, ניתן לצפות בתמונות ומסמכים ששימשו את המשתמש ביצירת הדוח,  ניתן להוריד את הדוח ולשתפו באמצעות שליחת מייל.']},
  {
    question: '<bold>מדוע איני יכול לערוך דוח ב- "מאגר הדוחות שלי"?</bold>',
    answer:['ב- "מאגר הדוחות שלי" מוצגים דוחות ישנים ודוחות שנוצרו באמצעות הפלטפורמה שלנו. דוחות ישנים אינם ניתנים לעריכה בפלטפורמה אלא רק באמצעות האדמין.']},
  {
    question: '<bold>כיצד והיכן ניתן לצפות בטיוטה של דוח שיצרתי בפלטפורמה?</bold>',
    answer: ['כדי לצפות בטיוטת דוח, על המשתמש להיכנס לתהליך עבודה ספציפי של אותו דוח שהוא יצר  בפלטפורמה. יש ללחוץ על כפתור "תצוגה מקדימה" במסך "תמונות ומסמכים". \n' +
    'כדי לשלוח את גרסת הטיוטה, לחצו על כפתור "שליחת טיוטה". לאחר לחיצה על הכפתור תתבקשו למלא כתובת מייל לשליחת הטיוטה. נדגיש שגרסת הטיוטה אינה כוללת את חתימת המשתמש.\n']
  },
  {
    question: '<bold>היכן ניתן לערוך תמונות ומסמכים שצירפתי בתהליך יצירת דוח?</bold>',
    answer: ['במסך תמונות ומסמכים - ליד הקובץ קיים אייקון "3 נקודות". לחיצה עליו תפתח סרגל עם אפשרויות שונות. בלחיצה על אפשרות עריכה:',
      'עבור קבצי pdf, המשתמש יכול לבחור אילו עמודים יוצגו בדוח הסופי.',
      'עבור קבצי ,jpg/png כמו למשל תצ"א ומפת ייעודי סביבה, המשתמש יכול לערוך את הקבצים באמצעות פעולות עריכה שונות.',
      'תמונות מיום הביקור בנכס ניתן לערוך את כותרת התמונה והקומה בה צולמה התמונה.',
    ]
  },
  {
    question: '<bold>מה נדרש על מנת להפיק דוח סופי כולל חתימות? מדוע הכפתור "אישור וסיום" במסך "תמונות ומסמכים" אינו לחיץ?</bold>',
    answer: ['בתהליך "דוח חדש", קיימים שדות רשות ושדות חובה. שדות החובה מסומנים בכוכבית אדומה. בסרגל העליון של המסכים יופיע "וי" ירוק במידה וכל שדות החובה באותו מסך מולאו, ו- "וי" אדום במידה וקיים שדה חובה שטרם מולא.\n' +
    // eslint-disable-next-line no-useless-concat
    'הפקת דוח סופי תתאפשר רק לאחר ' + '<underline>שכל שדות החובה מולאו וכל קבצי החובה צורפו</underline>'+' , לאורך המסכים השונים.']
  },
  {
    question: '<bold>מדוע איני מצליח להוריד את הדוח הסופי ממאגר המידע השיתופי?</bold>',
    answer: ['המאגר מכיל נתונים וקבצים מתוך הדוחות אך לא את הדוח הסופי עצמו, מאחר והקפדנו לשמור על סודיות פרטים אישיים המופיעים בדוחות סופיים, כגון פרטי מזמיני הדוחות ופרטי משרדי השמאים שביצעו את הדוחות.']
  },
  {
    question: '<bold>מדוע איני מצליח להוריד דוח מ- "מאגר הדוחות שלי" ומ- "מאגר דוחות המשרד"?</bold>',
    answer: ['הורדת דוח סופי תתאפשר רק כאשר הדוח נמצא בסטטוס "הסתיים". ']
  },
]
